import { render, staticRenderFns } from "./NotAuthLayout.vue?vue&type=template&id=bc8b906a&scoped=true"
import script from "./NotAuthLayout.vue?vue&type=script&lang=js"
export * from "./NotAuthLayout.vue?vue&type=script&lang=js"
import style0 from "./NotAuthLayout.vue?vue&type=style&index=0&id=bc8b906a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8b906a",
  null
  
)

export default component.exports